import type { FileJSON, GeoPointJSON, ParseDateJSON } from '../parse/parse';
import type { LocationData } from './location';

export const ParseJSON = {
	toFile(name: string, url: string): FileJSON {
		return {
			__type: 'File',
			name,
			url,
		};
	},

	fromFile(file: FileJSON): string {
		if (file == null) {
			return null;
		}
		return file.name;
	},

	fromDate(json: ParseDateJSON): Date {
		if (json == null) {
			return null;
		}
		return new Date(json.iso);
	},

	toDate(date: Date | null): ParseDateJSON | null {
		if (date == null) {
			return null;
		}
		return {
			__type: 'Date',
			iso: date.toJSON(),
		};
	},

	toGeoPoint(location: LocationData): GeoPointJSON {
		if (location == null) {
			return null;
		}

		return {
			type: 'point',
			coordinates: [location.longitude, location.latitude],
		};
	},

	fromGeoPoint(point: GeoPointJSON): LocationData {
		if (point == null) {
			return null;
		}

		return {
			longitude: point.coordinates[0],
			latitude: point.coordinates[1],
			altitude: 0,
		};
	},
};
